export default __webpack_public_path__ + "static/media/facebook-logo-button.daddf432.svg";